jQuery( document ).ready( function( $ ) {
	// Define the number of items to show
	const itemsToShow = 8;

	// Iterate over each taxonomy's ul
	$( 'form.searchandfilter > ul > li > ul' ).each( function() {
		const $thisUl = $( this );

		// If the taxonomy has more items than the defined limit
		if ( $thisUl.find( 'li' ).length > itemsToShow ) {
			// Hide all <li> items after the defined limit
			$thisUl.find( 'li:gt(' + ( itemsToShow - 1 ) + ')' ).hide();

			// Append the "See more" button after the current <ul>
			$thisUl.after( '<button class="toggleBtn" data-expanded="false">' + 'Bekijk meer +' + '</button>' );
		}
	} );

	// When "See more" or "See less" is clicked
	$( 'form.searchandfilter' ).on( 'click', '.toggleBtn', function( event ) {
		event.preventDefault();

		const $thisBtn = $( this );
		const $relatedUl = $thisBtn.prev( 'ul' );
		const isExpanded = $thisBtn.data( 'expanded' ) === 'true';

		// Toggle visibility of list items and button text
		$relatedUl.find( 'li:gt(' + ( itemsToShow - 1 ) + ')' ).toggle();
		$thisBtn.text( isExpanded ? 'Bekijk meer +' : 'Bekijk minder -' );

		// Toggle the state
		$thisBtn.data( 'expanded', ! isExpanded );
	} );

	$( '.filter-btn' ).on( 'click', function() {
		$( '.filter_product' ).toggleClass( 'show-filter' );
	} );

	// Toggle class when <a> is clicked
	const $form = $( '.item.search > form' );
	const $trigger = $( '.item.search > a' );

	$trigger.on( 'click', function( e ) {
		e.preventDefault();
		$form.toggleClass( 'show-form' );
	} );
} );
